import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import {
  blackColor,
  blackShade21,
  blueColor04,
  greyColor14,
  greyColor8,
  logoImgborder1,
  mobilePrimary,
  redColor,
  whiteColor,
  yellowShade03,
} from "../../configs/styles/muiThemes";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  Typography,
} from "@mui/material";
import { BULK_UPLOAD_STEPPER } from "../../utils/data";
import { useDispatch, useSelector } from "react-redux";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadInventoryDetails from "./DownloadInventoryDetails";
import UploadStepper from "./components/UploadStepper";
import UploadInventoryExcel from "./UploadInventoryExcel";
import ReviewInventoryDetails from "./ReviewInventoryDetails";
import {
  prepareDraftUpdatePostData,
  validateInventoryData,
} from "./inventoryBulkUpdateHelper";
import { updateInventoryData } from "../../service/api_calls/inventory/InventoryApi";
import InventoryUpdateSuccessful from "./InventoryUpdateSuccessful";
import { getCategoryDropdownListData } from "../../reducers/inventory/inventorySlice";
import {
  deleteBulkInventoryProductsApi,
  getAllBulkInventoryProductsApi,
  updateBulkInventoryDraftApi,
  uploadBulkInventoryProductApi,
} from "../../service/api_calls/BulkInventoryUpdate/BulkInventoryUpdateAPIs";
import { getProductsByBusinessAPI } from "../../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import ModalCard from "../../components/ModalCard";

const InventoryBulkUpdateContent = ({
  activeBusinessInfo,
  mainProducts,
  getAllMainProducts,
  commerceInfo,
}) => {
  const dispatch = useDispatch();

  const isCatalogPartner =
    commerceInfo?.info?.catalogPartnerInfo?.[0]?.status == "active";

  const [currentPage, setCurrentPage] = useState("download");
  // const [currentPage, setCurrentPage] = useState("review");
  const [showSnackBar, setShowSnackBar] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    selectedFile: null,
    errors: null,
  });

  const [draftInventoryData, setDraftInventoryData] = useState([]);
  const [selectedRowCount, setSelectedRowCount] = useState(0);

  const [updateLoader, setUpdateLoader] = useState(false);
  const [publishedInfo, setPublishedInfo] = useState(null);
  const [error, setError] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [isClearSearch, setIsClearSearch] = useState(false);

  const [filterType, setFilterType] = useState("");
  const [isClearFilter, setIsClearFilter] = useState(null);

  const [categoryInfo, setCategoryInfo] = useState(null);

  const [selectedOndcCategory, setSelectedOndcCategory] = useState("All");
  const [selectedOndcSubCat, setSelectedOndcSubCat] = useState("All");

  const { ondcDropdownData } = useSelector((state) => state.inventory);

  const [alertModal, setAlertModal] = useState({ show: false, type: "" });
  const [alertMsg, setAlertMsg] = useState("");

  const handleCloseSnackbar = () => {
    setShowSnackBar(false);
  };

  // Allow only backward navigation
  const handleStepperClick = (stepInfo) => {
    const currentPageInfo = BULK_UPLOAD_STEPPER.find(
      (item) =>
        item.pageName === currentPage || item?.pageTwoName === "addOndcSpecs"
    );

    if (stepInfo?.id > 2 && currentPageInfo?.id > stepInfo?.id) {
      setCurrentPage(stepInfo.pageName);
    }
  };

  // Upload Excel File
  const uploadSelectedFile = async () => {
    if (!fileDetails?.selectedFile) {
      setFileDetails((prevState) => ({
        ...prevState,
        errors: { selectedFile: "Please select a valid Excel sheet file." },
      }));
      return;
    }

    setIsLoading(true);

    const businessId = sessionStorage.getItem("selectedBusinessId");

    const response = await uploadBulkInventoryProductApi({
      selectedFile: fileDetails?.selectedFile,
      businessId,
    });

    await getDraftInventoryData();

    setIsLoading(false);
    setFileDetails(null);
    setCurrentPage("review");
  };

  // Handle Back
  const goBack = () => {
    switch (currentPage) {
      case "upload":
        setCurrentPage("download");
        return;

      case "review":
        // setCurrentPage("upload");
        break;

      default:
        break;
    }
  };

  // Handle Next
  const handleNext = () => {
    switch (currentPage) {
      case "upload":
        uploadSelectedFile();
        return;

      case "review":
        if (selectedRowCount == 0) {
          setError("Select at least one row");
          return;
        }
        setAlertMsg(
          `Do you want to proceed with updating ${selectedRowCount} ${
            selectedRowCount === 1 ? "row" : "rows"
          }`
        );
        setAlertModal({ show: "true", type: "update" });
        break;

      default:
        break;
    }
  };

  // Handle Select All Product
  const selectAllProductRows = (isSelected) => {
    const allProducts = draftInventoryData?.map((item) => ({
      ...item,
      isSelected: isSelected ? true : false,
    }));

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setDraftInventoryData((prevState) => allProducts);
    setSelectedRowCount(selectedCount);
    setError("");
  };

  // Toggle Indiviual Row Selection
  const toggleProductRowSelect = (index, isSelected) => {
    const allProducts = [...draftInventoryData];
    const productInfo = allProducts[index] || null;

    if (!productInfo) {
      setDraftInventoryData(allProducts || []);
      return;
    }

    const updatedProductInfo = {
      ...productInfo,
      isSelected: !isSelected,
    };

    allProducts[index] = updatedProductInfo;

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setDraftInventoryData(allProducts || []);
    setSelectedRowCount(selectedCount);
    setError("");
  };

  // Update Inventory
  const updateInventory = async () => {
    if (selectedRowCount == 0) {
      setError("Select at least one row");
      return;
    }

    setError("");

    console.log("BULK_INVENTORY___mainProducts", mainProducts);
    console.log("BULK_INVENTORY___draftInventoryData", draftInventoryData);
    const validate = validateInventoryData(
      draftInventoryData,
      mainProducts,
      false,
      isCatalogPartner
    );
    console.log("BULK_INVENTORY___validate", validate);

    if (validate?.isError) {
      setError(
        `Fix errors in ${validate?.errorCount} ${
          validate?.errorCount == 1 ? "Row" : "Rows"
        }`
      );
      setDraftInventoryData(validate?.allProducts);
      return;
    }

    setIsLoading(true);

    let postDataList = [];
    const businessId = sessionStorage.getItem("selectedBusinessId");
    // const businessProductRes = await getProductsByBusinessAPI(businessId);
    // const businessProduct = businessProductRes?.productList || []

    // console.log("BULK_INVENTORY___businessProduct", businessProduct);

    draftInventoryData?.forEach((item) => {
      if (!item.isSelected) return;

      // const origianProduct = businessProduct?.find(
      //   (product) => product?.id === item?.productId
      // );

      const origianProduct = item?.originalProdInfo || null;

      postDataList.push({
        productId: item?.productId,
        // skuId: "",
        businessId: businessId,
        minOrderQuantity: Number(origianProduct?.minOrderQuantity),
        maxOrderQuantity: Number(origianProduct?.maxOrderQuantity),
        availableQuantity: Number(item?.availableQuantity),
        alertQuantity: Number(origianProduct?.alertQuantity),
        availability: origianProduct?.availability || ["Yes"],
        hyperLocal: "Y",
        shipmentDistance: "5000",
        productSalePrice: Number(item?.productSalePrice),
        productOriginalPrice: Number(item?.productOriginalPrice),
        commerceStartDate: origianProduct?.commerceStartDate,
        commerceEndDate: origianProduct?.commerceEndDate,
        gstInfo: origianProduct?.gstInfo,
      });
    });

    console.log("BULK_INVENTORY___postDataList", postDataList);

    const updateRes = await updateInventoryData(postDataList, businessId);

    if (updateRes) {
      const draftUpdatePostData =
        prepareDraftUpdatePostData(draftInventoryData);
      console.log("BULK_INVENTORY___draftUpdatePostData", draftUpdatePostData);

      const res = await updateBulkInventoryDraftApi({
        businessId,
        postData: draftUpdatePostData,
      });

      setPublishedInfo({
        publishedProducts: postDataList?.length || 0,
      });
      setUpdateLoader(false);
      setCurrentPage("published");
    }
  };

  // Apply ONDC Filter
  const applyONDCFilter = async (categoryData, subCategoryData) => {
    const mainCatCode = categoryData?.ondcCode || "";
    const subCatCode = subCategoryData?.ondcSubCode || "";

    setCategoryInfo((prevState) => ({
      ...prevState,
      ondcMainCat: mainCatCode,
      ondcSubCat: subCatCode,
    }));

    setFilterType("ondc");

    setSearchQuery("");
    setIsClearSearch(false);

    const businessId = sessionStorage.getItem("selectedBusinessId");

    await getAllMainProducts(mainCatCode, subCatCode, "");

    // dispatch(
    //   filterInventoryOndcProducts({
    //     businessId,
    //     pageSize: PAGE_SIZE,
    //     pageNo: 1,
    //     ondcMainCat: mainCatCode,
    //     ondcSubCat: subCatCode,
    //     tabStatus: "all_stock",
    //     type: activeTab,
    //   })
    // ).then((res) => {
    //   if (
    //     res?.payload?.result?.length == 0 ||
    //     res?.payload?.result?.length < PAGE_SIZE
    //   ) {
    //     setHasMoreData(false);
    //   }
    // });
  };

  // Get Draft Inventory Data
  const getDraftInventoryData = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    setUpdateLoader(true);
    const response = await getAllBulkInventoryProductsApi({ businessId });

    const updatedList = response?.map((item) => {
      const originalProdInfo = mainProducts?.find(
        (product) => item?.productId === product?.id
      );
      return { ...item, originalProdInfo };
    });

    const selectedCount = updatedList?.filter(
      (item) => item?.isSelected
    ).length;

    setDraftInventoryData(updatedList || []);
    setSelectedRowCount(selectedCount || 0);
    setUpdateLoader(false);
  };

  // Delete Rows
  const deleteRows = async (deleteIds) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    setUpdateLoader(true);
    const response = await deleteBulkInventoryProductsApi({
      businessId,
      deleteIds,
    }).then((res) => {
      getDraftInventoryData();
      setUpdateLoader(false);
    });
  };

  //handle delete Selected Rows
  const deleteSelectedRows = () => {
    const rowIds = draftInventoryData
      ?.filter((item) => item?.isSelected)
      ?.map((item) => item?.id);

    deleteRows(rowIds);
  };

  // Handle Search
  const handleSearch = async () => {
    if (!searchQuery) return;

    await getAllMainProducts("", "", searchQuery);

    setFilterType("");
    setIsClearFilter(null);

    setSelectedOndcCategory("All");
    setSelectedOndcSubCat("All");

    setIsClearSearch(true);
  };

  const clearSearchFilter = () => {
    getAllMainProducts();
    setIsClearSearch(false);
    setIsClearFilter(false);
    setSearchQuery("");
  };

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    // Fetching ONDC Dropdown Data
    if (ondcDropdownData?.length === 0) {
      dispatch(getCategoryDropdownListData(businessId));
    }

    return () => {};
  }, []);

  useEffect(() => {
    if (mainProducts?.length > 0) {
      getDraftInventoryData();
    }

    return () => {};
  }, [mainProducts]);

  return (
    <Box sx={styles.card}>
      <UploadStepper
        currentPage={currentPage}
        handleStepperClick={handleStepperClick}
      />

      {currentPage === "loading" ? (
        <ThreeDotLoader />
      ) : (
        <Box mt={2}>
          {currentPage === "download" && (
            <DownloadInventoryDetails
              isCatalogPartner={isCatalogPartner}
              catalogPartner={
                commerceInfo?.info?.catalogPartnerInfo?.[0]?.catalogPartner
              }
              businessName={activeBusinessInfo?.name || ""}
              productDetails={mainProducts}
              onUpload={() => setCurrentPage("upload")}
              gotoReview={() => setCurrentPage("review")}
              draftInventoryData={draftInventoryData}
              // Filter & Search Props
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handleSearch={handleSearch}
              applyONDCFilter={applyONDCFilter}
              isClearFilter={isClearFilter}
              setIsClearFilter={setIsClearFilter}
              filterType={filterType}
              setFilterType={setFilterType}
              isClearSearch={isClearSearch}
              setIsClearSearch={setIsClearSearch}
              clearSearchFilter={clearSearchFilter}
              // ONDC Category
              ondcDropdownData={ondcDropdownData}
              selectedOndcCategory={selectedOndcCategory}
              setSelectedOndcCategory={setSelectedOndcCategory}
              selectedOndcSubCat={selectedOndcSubCat}
              setSelectedOndcSubCat={setSelectedOndcSubCat}
              refreshProductList={() => {}}
            />
          )}

          {currentPage === "upload" && (
            <UploadInventoryExcel
              isCatalogPartner={isCatalogPartner}
              fileDetails={fileDetails}
              setFileDetails={setFileDetails}
              data={draftInventoryData}
              setData={setDraftInventoryData}
            />
          )}

          {currentPage === "review" && (
            <ReviewInventoryDetails
              isCatalogPartner={isCatalogPartner}
              productDetails={draftInventoryData}
              setProductDetails={setDraftInventoryData}
              isLoading={isLoading}
              selectedRowCount={selectedRowCount}
              setCurrentPage={setCurrentPage}
              selectAllProductRows={selectAllProductRows}
              toggleProductRowSelect={toggleProductRowSelect}
              deleteRows={deleteRows}
            />
          )}

          {currentPage === "published" && (
            <InventoryUpdateSuccessful
              isCatalogPartner={isCatalogPartner}
              publishedInfo={publishedInfo?.publishedProducts}
            />
          )}

          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={showSnackBar}
            autoHideDuration={3000}
            onClose={() => {
              handleCloseSnackbar();
            }}
            sx={{ mt: 4 }}
          >
            <Alert
              onClose={() => {
                handleCloseSnackbar();
              }}
              severity="success"
              icon={<DeleteOutlineIcon fontSize="inherit" />}
              variant="filled"
              sx={{ width: "100%" }}
            >
              Deleted Rows
            </Alert>
          </Snackbar>

          {currentPage !== "download" &&
            currentPage !== "published" &&
            (currentPage !== "review" || draftInventoryData?.length > 0) &&
            mainProducts?.length > 0 && (
              <>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={2}
                  mt={2}
                >
                  <Button
                    variant="contained"
                    sx={styles.backBtn}
                    disableElevation
                    onClick={goBack}
                    disabled={isLoading || updateLoader}
                  >
                    BACK
                  </Button>

                  {currentPage == "review" && (
                    <Button
                      variant="outlined"
                      sx={styles.deleteBtn}
                      onClick={() => {
                        if (selectedRowCount == 0) {
                          setError("Select at least one row to delete");
                          return;
                        }

                        setAlertMsg(`Do you want to delete the selected rows?`);
                        setAlertModal({ show: true, type: "delete" });
                      }}
                      disabled={isLoading || updateLoader}
                    >
                      Delete ({selectedRowCount}{" "}
                      {selectedRowCount === 1 ? "Row" : "Rows"})
                    </Button>
                  )}

                  <Box>
                    <Button
                      variant="contained"
                      sx={styles.nextBtn(false)}
                      disableElevation
                      onClick={handleNext}
                      disabled={isLoading || updateLoader}
                      startIcon={
                        (isLoading || updateLoader) && (
                          <CircularProgress
                            sx={{ color: greyColor14, opacity: 0.5 }}
                            size={16}
                          />
                        )
                      }
                    >
                      {currentPage == "review"
                        ? `VERIFY & IMPORT (${selectedRowCount} ${
                            selectedRowCount === 1 ? "Row" : "Rows"
                          })`
                        : "NEXT"}
                    </Button>
                  </Box>

                  {error && (
                    <Typography fontSize={11} fontWeight={500} color="red">
                      {error}
                    </Typography>
                  )}
                </Box>
              </>
            )}
        </Box>
      )}

      <ModalCard
        open={alertModal?.show}
        handleClose={() => {
          setAlertModal({ show: false, type: "" });
        }}
        width="27%"
      >
        <Box
          sx={{
            backgroundColor: whiteColor,
            px: 3,
            py: 2.5,
            borderRadius: 2,
          }}
        >
          <Typography fontSize={16} fontWeight={600} color={blackColor}>
            {alertModal?.type == "delete" ? "Alert" : "Confirmation"}
          </Typography>
          <Typography fontSize={14} mt={1.5}>
            {alertMsg}
          </Typography>
          <Box display="flex" justifyContent={"flex-end"} mt={3} gap={2}>
            <Button
              sx={styles.fillBtn}
              onClick={() => {
                setAlertModal({ show: false, type: "" });
              }}
            >
              No
            </Button>

            <Button
              sx={styles.addIconBtn}
              onClick={() => {
                if (alertModal?.type == "update") {
                  updateInventory();
                } else {
                  deleteSelectedRows();
                }
                setAlertModal({ show: false, type: "" });
              }}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </ModalCard>
    </Box>
  );
};

export default InventoryBulkUpdateContent;

const styles = {
  card: {
    backgroundColor: whiteColor,
    border: logoImgborder1,
    borderRadius: { xs: "8px", md: "10px" },
    p: { xs: "12px", md: "15px" },
    boxShadow: "0 0px 4px 0 rgb(0 0 0 / 5%)",
    m: { xs: "15px 0 25px", md: "0px 0 25px" },
  },

  backBtn: {
    fontSize: 11,
    fontWeight: 600,
    color: blackShade21,
    backgroundColor: whiteColor,
    border: `1px solid ${blackShade21}`,
    padding: "6px 25px",
    borderRadius: "5px",
    "&:hover": {
      color: whiteColor,
      backgroundColor: blackShade21,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },

  assignBtn: {
    color: blueColor04,
    border: `1px solid ${blueColor04}`,
    backgroundColor: whiteColor,
    "&:hover": {
      color: whiteColor,
      backgroundColor: blueColor04,
    },
  },

  nextBtn: (isDisabled) => ({
    fontSize: 12,
    fontWeight: 500,
    color: blackColor,
    backgroundColor: yellowShade03,
    border: isDisabled ? "none" : `1px solid ${yellowShade03}`,
    padding: "6px 25px",
    borderRadius: "5px",
    "&:hover": {
      color: yellowShade03,
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  }),

  deleteBtn: {
    fontSize: 11,
    fontWeight: 600,
    color: redColor,
    border: `1px solid ${redColor}`,
    padding: "7px 25px",
    "&:hover": {
      color: whiteColor,
      bgcolor: redColor,
      border: `1px solid ${redColor}`,
    },
  },

  addIconBtn: {
    padding: { md: "3px 16px", xs: "3px 14px" },
    fontSize: { md: "11px", xs: "11px" },
    fontWeight: 600,
    color: { xs: mobilePrimary, md: blueColor04 },
    backgroundColor: whiteColor,
    border: {
      xs: `1.5px solid ${mobilePrimary}`,
      md: `1.5px solid ${blueColor04}`,
    },
    "&:hover": {
      color: whiteColor,
      backgroundColor: { xs: mobilePrimary, md: blueColor04 },
    },
  },
  fillBtn: {
    backgroundColor: greyColor8,
    padding: "6px 22px",
    fontSize: "11px",
    fontWeight: 600,
    color: whiteColor,
    border: "1.5px solid " + greyColor8,
    "&:hover": {
      color: greyColor8,
      backgroundColor: whiteColor,
    },
  },
};
